
// // // // import React from "react";
// // // // import "./CustomInputLogin.css";
// // // // import "../ComponentsCss/componet.css";
// // // // import { Field, ErrorMessage } from "formik";
// // // // import { InputAdornment } from "@mui/material";
// // // // import { Email } from "@mui/icons-material";

// // // // const CustomInputLogin = ({ label, name, custPlaceholder, image, inputType, ...rest }) => {
// // // //   const validateInput = (value) => {
// // // //     let error;
// // // //     if (!value) {
// // // //       error = `Field is Required`;
// // // //     } else if (inputType === "number" && isNaN(value)) {
// // // //       error = "Field is Required";
// // // //     }
// // // //     return error;
// // // //   };

// // // //   return (
// // // //     <div style={{ width: "100%" }}>
// // // //       <div style={{ width: "100%" }}>
// // // //         <div>
// // // //           <label
// // // //             htmlFor={name}
// // // //             className="input-heading12"
// // // //             style={{ fontSize: "16px" }}
// // // //           >
// // // //             {label}
// // // //           </label>
// // // //         </div>
// // // //         <div style={{ position: "relative", width: "100%" }}>
// // // //           {/* Email Icon as Start Adornment */}
// // // //           {/* {image && (
// // // //             < InputAdornment position="start" style={{ position: "absolute", top: "50%", left: "8px", transform: "translateY(-50%)" }}>
// // // //               <img src={image} style={{ color: "black", height: "17px" }} />
// // // //             </InputAdornment>
// // // //           )} */} 
// // // //           {/* Input Field */}
// // // //           <Field
// // // //             id={name}
// // // //             name={name}
// // // //             as={inputType === "textarea" ? "textarea" : "input"}
// // // //             placeholder={custPlaceholder || "Enter Input"}
// // // //             {...rest}
// // // //             style={{

// // // //               borderRadius:"3px",
// // // //               width: "100%",
// // // //               color: "#7A7A7A",

// // // //               // paddingLeft: "40px", // Add padding to accommodate the icon
// // // //               boxSizing: "border-box",
// // // //               height: inputType === "textarea" ? "100px" : "35px",
// // // //               paddingLeft: inputType === "textarea" ? "10px" : "10px" // Add padding to accommodate the icon

// // // //             }}
// // // //             // sx={inputType === "textarea" ? { height: "100px" || "100px" } : {}}
// // // //             className="custominput-field12"
// // // //             validate={validateInput}

// // // //           />
// // // //         </div>
// // // //         <ErrorMessage
// // // //           name={name}
// // // //           component="div"
// // // //           // fontSize="10px"
// // // //           // className="inputs-error-msg"
// // // //           style={{ color: "red",fontSize:"12px" }}
// // // //           // sx={{fontSize:"30px"}}
// // // //         />
// // // //       </div>
// // // //     </div >
// // // //   );
// // // // };

// // // // export default CustomInputLogin;




// // // import React from "react";
// // // import "../CustomInputLogin/CustomInputLogin.css";
// // // import "../ComponentsCss/componet.css";
// // // import { Field, ErrorMessage } from "formik";
// // // import { InputAdornment, Typography } from "@mui/material";
// // // import { Email } from "@mui/icons-material";
// // // import { FaStarOfLife } from "react-icons/fa6";
// // // import { useField } from "formik";


// // // const CustomInpuWithEmoji = ({ label, name, custPlaceholder, image, important,handleChange, inputType, ...rest }) => {
// // //   // const validateInput = (value) => {
// // //   //   let error;
// // //   //   if (!value) {
// // //   //     error = `Field is Required`;
// // //   //   } else if (inputType === "number" && isNaN(value)) {
// // //   //     error = "Field is Required";
// // //   //   }
// // //   //   return error;
// // //   // };
// // //   const [field, meta] = useField(name);




// // //   return (
// // //     <div style={{ width: "100%" }}>
// // //       <div style={{ width: "100%" }}>
// // //         <div
// // //           style={{ marginBottom: "1px" }}
// // //         >
// // //           <Typography variant="body1">
// // //             <label
// // //               htmlFor={name}
// // //               className="input-heading12"
// // //               style={{ fontSize: "15px", fontWeight: "450",color:"black" }}
// // //             >
// // //               {label}
// // //             </label>

// // //             {important && (
// // //               <FaStarOfLife style={{ color: '#F53E5C', fontSize: "8px", marginLeft: "3px" }} />
// // //             )}
// // //           </Typography>
// // //         </div>
// // //         <div style={{ position: "relative", width: "100%" }}>
// // //           {/* Email Icon as Start Adornment */}
// // //           {image && (
// // //             < InputAdornment position="start" style={{ position: "absolute", top: "50%", left: "8px", transform: "translateY(-50%)" }}>
// // //               <img src={image} style={{ color: "black", height: "17px" }} />
// // //             </InputAdornment>
// // //           )}
// // //           {/* Input Field */}
// // //           <Field
// // //             id={name}
// // //             // inputType={inputType}
// // //             // onChange={handleChange}
// // //             type={inputType !== "textarea" ? inputType : "text"}
// // //             name={name}
// // //             as={inputType === "textarea" ? "textarea" : "input"}
// // //             placeholder={custPlaceholder || "Enter Input"}
// // //             {...rest}

// // //             style={{
// // //               width: "100%",
// // //               borderRadius: "3px",
// // //               // paddingLeft: "40px", // Add padding to accommodate the icon
// // //               boxSizing: "border-box",
// // //               height: inputType === "textarea" ? "100px" : "35px",
// // //               paddingLeft: inputType === "textarea" ? "10px" : "10px" // Add padding to accommodate the icon

// // //             }}
// // //             // sx={inputType === "textarea" ? { height: "100px" || "100px" } : {}}
// // //             className="custominput-field12"
// // //             // validate={validateInput}
// // //           />
// // //         </div>

// // //         <ErrorMessage
// // //           name={name}
// // //           component="div"
// // //           className="inputs-error-msg"
// // //           style={{ color: "red", fontSize: "12px", fontWeight: '400' }}
// // //         />
// // //       </div>
// // //     </div >
// // //   );
// // // };

// // // export default CustomInpuWithEmoji;


// // import React, { useState } from "react";
// // import "../CustomInputLogin/CustomInputLogin.css";
// // import "../ComponentsCss/componet.css";
// // import { Field, ErrorMessage, useFormikContext } from "formik";
// // import { InputAdornment, Typography, IconButton } from "@mui/material";
// // import { FaStarOfLife } from "react-icons/fa6";
// // import { useField } from "formik";
// // import EmojiPicker from 'emoji-picker-react';
// // import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';

// // const CustomInputWithEmoji = ({ label, name, custPlaceholder, image, important, inputType, ...rest }) => {
// //   const [field, meta] = useField(name);
// //   const { setFieldValue } = useFormikContext();
// //   const [showPicker, setShowPicker] = useState(false);

// //   const handleEmojiClick = (emojiObject) => {
// //     setFieldValue(name, (field.value || '') + emojiObject.emoji);
// //   };

// //   return (
// //     <div style={{ width: "100%", position: "relative" ,overflow: "visible"}}>
// //       <div>
// //         <Typography variant="body1">
// //           <label htmlFor={name} className="input-heading12" style={{ fontSize: "15px", fontWeight: "450", color: "black" }}>
// //             {label}
// //           </label>
// //           {important && (
// //             <FaStarOfLife style={{ color: '#F53E5C', fontSize: "8px", marginLeft: "3px" }} />
// //           )}
// //         </Typography>
// //       </div>

// //       <div style={{ position: "relative", width: "100%" ,overflow: "visible" }}>
// //         {image && (
// //           <InputAdornment position="start" style={{ position: "absolute", top: "50%", left: "8px", transform: "translateY(-50%)" }}>
// //             <img src={image} style={{ height: "17px" }} alt="icon" />
// //           </InputAdornment>
// //         )}

// //         {/* Input Field with Emoji */}
// //         <Field
// //           id={name}
// //           name={name}
// //           as={inputType === "textarea" ? "textarea" : "input"}
// //           type={inputType !== "textarea" ? inputType : "text"}
// //           placeholder={custPlaceholder || "Enter Input"}
// //           {...field}
// //           {...rest}
// //           style={{
// //             width: "100%",
// //             borderRadius: "3px",
// //             boxSizing: "border-box",
// //             height: inputType === "textarea" ? "100px" : "35px",
// //             paddingLeft: "10px"
// //           }}
// //           className="custominput-field12"
// //         />

// //         {/* Emoji Button */}
// //         <IconButton
// //           onClick={() => setShowPicker(!showPicker)}
// //           style={{ position: "absolute", right: "5px", top: inputType === "textarea" ? "10px" : "5px" }}
// //         >
// //           <EmojiEmotionsIcon fontSize="small" />
// //         </IconButton>
// //       </div>

// //       {showPicker && (
// //         <div
// //           style={{
// //             position: "absolute",
// //             top: inputType === "textarea" ? "110px" : "45px", // push below input/textarea
// //             left: 0,
// //             zIndex: 10,
// //           }}
// //         >
// //           <EmojiPicker onEmojiClick={handleEmojiClick} />
// //         </div>
// //       )}


// //       <ErrorMessage
// //         name={name}
// //         component="div"
// //         className="inputs-error-msg"
// //         style={{ color: "red", fontSize: "12px", fontWeight: '400' }}
// //       />
// //     </div>
// //   );
// // };

// // export default CustomInputWithEmoji;

// import React, { useState } from "react";
// import ReactDOM from "react-dom";
// import "../CustomInputLogin/CustomInputLogin.css";
// import "../ComponentsCss/componet.css";
// import { Field, ErrorMessage, useFormikContext } from "formik";
// import { InputAdornment, Typography, IconButton } from "@mui/material";
// import { FaStarOfLife } from "react-icons/fa6";
// import { useField } from "formik";
// import EmojiPicker from "emoji-picker-react";
// import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";

// const CustomInputWithEmoji = ({
//   label,
//   name,
//   custPlaceholder,
//   image,
//   important,
//   inputType,
//   ...rest
// }) => {
//   const [field, meta] = useField(name);
//   const { setFieldValue } = useFormikContext();
//   const [showPicker, setShowPicker] = useState(false);
//   const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

//   const inputRef = React.useRef();

//   const handleEmojiClick = (emojiObject) => {
//     setFieldValue(name, (field.value || "") + emojiObject.emoji);
//   };

//   const toggleEmojiPicker = () => {
//     if (inputRef.current) {
//       const rect = inputRef.current.getBoundingClientRect();
//       setPickerPosition({
//         top: rect.bottom + window.scrollY,
//         left: rect.left + window.scrollX,
//       });
//     }
//     setShowPicker((prev) => !prev);
//   };

//   return (
//     <div style={{ width: "100%", position: "relative" }}>
//       <div>
//         <Typography variant="body1">
//           <label
//             htmlFor={name}
//             className="input-heading12"
//             style={{
//               fontSize: "15px",
//               fontWeight: "450",
//               color: "black",
//             }}
//           >
//             {label}
//           </label>
//           {important && (
//             <FaStarOfLife
//               style={{ color: "#F53E5C", fontSize: "8px", marginLeft: "3px" }}
//             />
//           )}
//         </Typography>
//       </div>

//       <div style={{ position: "relative", width: "100%" }}>
//         {image && (
//           <InputAdornment
//             position="start"
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: "8px",
//               transform: "translateY(-50%)",
//             }}
//           >
//             <img src={image} style={{ height: "17px" }} alt="icon" />
//           </InputAdornment>
//         )}

//         <Field
//           id={name}
//           name={name}
//           as={inputType === "textarea" ? "textarea" : "input"}
//           type={inputType !== "textarea" ? inputType : "text"}
//           placeholder={custPlaceholder || "Enter Input"}
//           {...field}
//           {...rest}
//           style={{
//             width: "100%",
//             borderRadius: "3px",
//             boxSizing: "border-box",
//             height: inputType === "textarea" ? "100px" : "35px",
//             paddingLeft: "10px",
//           }}
//           className="custominput-field12"
//           innerRef={inputRef}
//           ref={inputRef}
//         />

//         {/* Emoji Button */}
//         <IconButton
//           onClick={toggleEmojiPicker}
//           style={{
//             position: "absolute",
//             right: "5px",
//             top: inputType === "textarea" ? "10px" : "5px",
//           }}
//         >
//           <EmojiEmotionsIcon fontSize="small" />
//         </IconButton>
//       </div>

//       {/* Emoji Picker rendered in portal */}
//       {showPicker &&
//         ReactDOM.createPortal(
//           <div
//             style={{
//               position: "absolute",
//               top: pickerPosition.top,
//               left: pickerPosition.left,
//               zIndex: 9999,
//             }}
//           >
//             <EmojiPicker onEmojiClick={handleEmojiClick} />
//           </div>,
//           document.body
//         )}

//       <ErrorMessage
//         name={name}
//         component="div"
//         className="inputs-error-msg"
//         style={{ color: "red", fontSize: "12px", fontWeight: "400" }}
//       />
//     </div>
//   );
// };

// export default CustomInputWithEmoji;



import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import "../CustomInputLogin/CustomInputLogin.css";
import "../ComponentsCss/componet.css";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { InputAdornment, Typography, IconButton, Box } from "@mui/material";
import { FaStarOfLife } from "react-icons/fa6";
import { useField } from "formik";
import EmojiPicker from "emoji-picker-react";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";

const CustomInputWithEmoji = ({
  label,
  name,
  custPlaceholder,
  image,
  important,
  inputType,
  ...rest
}) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const [showPicker, setShowPicker] = useState(false);
  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

  const inputRef = useRef();
  const pickerRef = useRef();
  const emojiBtnRef = useRef();

  const handleEmojiClick = (emojiObject) => {
    setFieldValue(name, (field.value || "") + emojiObject.emoji);
  };

  const toggleEmojiPicker = () => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      setPickerPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
    setShowPicker((prev) => !prev);
  };

  // 👉 Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        !emojiBtnRef.current.contains(event.target)
      ) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div>
        <Typography variant="body1">
          <label
            htmlFor={name}
            className="input-heading12"
            style={{
              fontSize: "15px",
              fontWeight: "450",
              color: "black",
            }}
          >
            {label}
          </label>
          {important && (
            <FaStarOfLife
              style={{ color: "#F53E5C", fontSize: "8px", marginLeft: "3px" }}
            />
          )}
        </Typography>
      </div>

      <div style={{ position: "relative", width: "100%" }}>
        {image && (
          <InputAdornment
            position="start"
            style={{
              position: "absolute",
              top: "50%",
              left: "8px",
              transform: "translateY(-50%)",
            }}
          >
            <img src={image} style={{ height: "17px" }} alt="icon" />
          </InputAdornment>
        )}

        <Field
          id={name}
          name={name}
          as={inputType === "textarea" ? "textarea" : "input"}
          type={inputType !== "textarea" ? inputType : "text"}
          placeholder={custPlaceholder || "Enter Input"}
          {...field}
          {...rest}
          style={{
            width: "100%",
            borderRadius: "3px",
            boxSizing: "border-box",
            height: inputType === "textarea" ? "100px" : "35px",
            paddingLeft: "40px",
          }}
          className="custominput-field12"
          innerRef={inputRef}
          ref={inputRef}
        />

        {/* Emoji Button */}
        <IconButton
          onClick={toggleEmojiPicker}
          ref={emojiBtnRef}
          style={{
            position: "absolute",
            left: "0px",
            top: inputType === "textarea" ? "10px" : "0px",
          }}
        >
          <EmojiEmotionsIcon fontSize="small" />
        </IconButton>
      </div>

      {/* Emoji Picker rendered in portal */}
      {showPicker &&
        ReactDOM.createPortal(
          <Box
            ref={pickerRef}
            sx={{
              position: "absolute",
              top: { xs: pickerPosition.top, md: 40 },
              // top: pickerPosition.top,

              // bottom: pickerPosition.bottom,
              left: { xs: pickerPosition.left, md: 0 },
              zIndex: 9999,
              width: { xs: "250px", md: "360px" },
              overflowX: { xs: "scroll", md: "hidden" }
            }}
          >
            <EmojiPicker onEmojiClick={handleEmojiClick} />
          </Box>,
          document.body
        )}

      <ErrorMessage
        name={name}
        component="div"
        className="inputs-error-msg"
        style={{ color: "red", fontSize: "12px", fontWeight: "400" }}
      />
    </div>
  );
};

export default CustomInputWithEmoji;
